import React from "react";
import PropTypes from "prop-types";
import { FluentDialog2 } from "../../../../../components/FluentUI/Fluent-Dialog2";
import { FluentButton } from "../../../../../components/FluentUI/Fluent-Button";
import { FluentField } from "../../../../../components/FluentUI/Fluent-Field";

const MultiOwnerConfirmationModal = ({
  open,
  setOpen,
  projectType,
  onCancel,
  onConfirm,
}) => {
  const handleCancel = () => {
    setOpen(false);
    onCancel();
  };

  const handleConfirm = () => {
    onConfirm();
  };

  const handleOpenChange = (_, data) => {
    setOpen(data.open);
  };

  return (
    <FluentDialog2 open={open} setOpen={handleOpenChange}>
      <div>
        <FluentField label="Confirm Action" />
        <div className="bold h6">
          Enable Multiple Project Owners for '{projectType}' Project Template?
        </div>
      </div>
      <div>
        <p>
          You're about to enable <strong>Multiple Project Owners</strong> for
          this Project Template.
        </p>
        <p>
          This change is <strong>permanent</strong> and cannot be undone once
          saved.
        </p>
      </div>
      <div></div>
      <div style={{ display: "flex", gap: "8px" }}>
        <FluentButton
          onClick={handleCancel}
          appearance="secondaryWithOutline"
          text="Cancel"
        />
        <div style={{ flex: 1, width: "237px" }}>
          <FluentButton
            onClick={handleConfirm}
            appearance="primary"
            text="Enable Multiple Owners and Save"
            className="btn-wide"
          />
        </div>
      </div>
    </FluentDialog2>
  );
};

MultiOwnerConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  projectType: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default MultiOwnerConfirmationModal;
